@if (_icon()) {
  <mat-icon class="tt-banner_icon" [icon]="_icon()" [iconSize]="16" />
}

<span class="tt-banner_message">
  {{ message() }}
  <ng-content />
</span>

<ng-content select="[ttBannerAction]" />
